import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import {setLoadingSequence} from 'actions/index.js';
import '../Sequences.css';

class SequencesView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sequences: [],
            folders: [],
            selectedFolder: null,
            selectedSequences: [],
        };

        this.getSequences();
        this.getFolders();
    }

    getSequences() {
        let url = this.state.selectedFolder !== null ?
            '/getSequences/ ' + this.state.selectedFolder :
            '/getSequences/';
        axios.get(url)
            .then((ret) => {
                console.log(ret.data);

                this.state.sequences = ret.data.data;
                this.setState(this.state);
            });
    }

    getFolders() {
        axios.get('/folders')
            .then((ret) => {
                console.log('folders');
                console.log(ret.data);

                this.state.folders = ret.data.data;
                this.setState(this.state);
            });
    }

    onClickFolder(id) {
        this.state.selectedFolder = this.state.selectedFolder == id ? null : id;
        this.setState(this.state);
    }

    newFolder() {
        let folderName = window.prompt('Type the new folders name');
        let self = this;
        axios.post('/newFolder/' + folderName)
            .then((ret) => {
                console.log('folder id = ' + ret.folderId);
                self.getFolders();
            });
    }

    onSelectSequence(sequence) {
        let index = this.state.selectedSequences.indexOf(sequence);

        if (index > -1) {
            this.state.selectedSequences = this.state.selectedSequences.slice(index, 1);
        } else {
            this.state.selectedSequences.push(sequence);
        }

        console.log('selected sequences');
        console.log(this.state.selectedSequences);
        this.setState(this.state);
    }

    filterToFolder() {
        this.getSequences();
    }

    moveToFolder() {
        let self = this;
        if (this.state.selectedSequences.length > 0 &&
            this.state.selectedFolder != null) {
            axios.post('/addSequencesToFolder/' + this.state.selectedSequences.join('+') + '/' + this.state.selectedFolder)
                .then(ret => {
                    self.setState(self.state);
                });
        }
    }

    render() {
        return (
            <div>
              <div>SEQUENCES</div>
              <div className="sequences-table">
                {this.state.sequences.map((sequence) =>
                <SequenceView selected={this.state.selectedSequences.indexOf(sequence.id) > -1} onSelectSequence={() => this.onSelectSequence(sequence.id)} sequence={sequence}/>)}
              </div>
                <div className="folders-table">
                <div className="new-folder" onClick={() => this.newFolder()}>NEW FOLDER</div>
                <div className="move-to-folder" onClick={() => this.moveToFolder()}>MOVE TO FOLDER</div>
                <div className="filter-to-folder" onClick={() => this.filterToFolder()}>FILTER</div>
                {this.state.folders.map((folder) =>
                                        <FolderView selected={this.state.selectedFolder == folder.id} onClickFolder={() => this.onClickFolder(folder.id)} folder={folder}/>)}
                </div>
            </div>);
    }
}

class SequenceView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div onClick={this.props.onSelectSequence} className={this.props.selected ? "sequence selected" : "sequence"}>
              <span className="sequence-name"><a href={'/create/' + this.props.sequence.id}>{this.props.sequence.name}</a></span>
              <div className="sequence-date">{this.props.sequence.date}</div>
            </div>
        );
    }
}

class FolderView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.selected ? "folder selected" : "folder"}>
              <div onClick={this.props.onClickFolder} className="folder-name">{this.props.folder.name}</div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLoadingSequence: (id, loading) => dispatch(setLoadingSequence(id, loading)),
    };
};
 

export default connect(null, mapDispatchToProps)(SequencesView);
